import { render } from "./comunicaciones.vue?vue&type=template&id=64c2af31&scoped=true"
import script from "./comunicaciones.vue?vue&type=script&lang=js"
export * from "./comunicaciones.vue?vue&type=script&lang=js"

import "./comunicaciones.vue?vue&type=style&index=0&id=64c2af31&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c2af31"]])

export default __exports__